import Vue from 'vue'
import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload, {
  error: require('../assets/images/logo.png'),
  loading: require('../assets/images/loading.gif')
})
